import { useCallback } from 'react'
import { Active, DragEndEvent, Over, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'

export function useSortableHandle(cb: (active: Active, over: Over) => void) {
  const sensors = useSensors(useSensor(PointerSensor))

  const handleDragEnd = useCallback(
    (e: DragEndEvent) => {
      const { active, over } = e
      if (over && active.id !== over.id) {
        cb(active, over)
      }
    },
    [cb]
  )

  return { sensors, handleDragEnd }
}
